import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const HeaderStyled = styled(FlexContainer)`
  padding: 0.75rem 0;
  border-bottom: ${({ theme }) => `${theme.borders.sm} ${theme.colors.primary.variant3}`};
  white-space: nowrap;
  overflow-x: auto;
  margin: 1.25rem 0.5rem 0 1rem;

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      padding: 1.25rem 0;
    }
  `}
`;
